module.exports = {
  localeName: 'hu-HU'
};
